<template>
  <div
    v-if="section === currentSection"
    :class="sectionClass"
    :ref="section.name || section"
    :key="section.name"
    :id="'Section_' + section.name"
  >
    <div class="tabdisableoverlay" v-if="section.tabDisabled">
      <h1 class="text-danger font-400">
        <i class="fa fa-ban fa-fw"></i>Zakładka jest wyłączona z edycji
      </h1>
    </div>
    <div v-else-if="section.unlockInfo && section.unlockInfo.length && !section.tabDisabled">
      <h4 class="no-padding margin-bottom-5 text-warning">
        <i class="fa fa-warning fa-fw"></i>Opis wymaganych zmian
      </h4>
      <div class="alert alert-warning" style="white-space: pre-wrap;">{{ section.unlockInfo }}</div>
    </div>

    <h1 v-if="section.description" v-html="section.description"></h1>
    <slot></slot>
  </div>
</template>

<script>
let letters = ['', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
let bletters = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
let rletters = ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x', 'x', 'xii'];
let rbletters = ['', 'I', 'II', 'II', 'III', 'IV', 'V', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
let leveltypes = ['1.', 'a)', 'i.'];

import slownie from '@witkac/jschema/lib/methods/slownie';

function renumber(el) {
  // console.time('renumber');
  // console.time('elemget');
  if (!el || !el.getElementsByClassName) {
    return;
  }
  var elems = el.getElementsByClassName('next-number');
  // console.timeEnd('elemget');
  // console.log('elems', elems);
  let levels = [];
  for (let i = 0; i < elems.length; i++) {
    var elem = elems[i];
    // console.log(i, elem.offsetParent);
    if (elem.offsetParent !== null) {
      let dataset = elem.dataset;
      // console.log('dataset', dataset);
      // widoczny
      let level = (dataset && dataset.level && +elem.dataset.level) || 0;

      //if (dataset && dataset.level) {
      //  level = +elem.dataset.level;
      //}

      let type = (dataset && dataset.type) || leveltypes[level];

      /*

      let type = leveltypes[level];

      if (dataset && dataset.type) {
        type = dataset.type;
      }
      */

      let prevLevelValue = levels[level] || 0;
      // console.log('prevLevelValue', prevLevelValue);

      let value = (dataset && dataset.value && +dataset.value) || prevLevelValue + 1;

      // let value = prevLevelValue + 1;

      if (dataset && dataset.value) {
        value = +dataset.value;
      }
      let s = '';

      switch (type) {
        case '1':
        case '1.':
          s = value + '.';
          break;
        case '1)':
          s = value + ')';
          break;
        case '(1)':
          s = '(' + value + ')';
          break;

        case 'a':
        case 'a)':
          s = letters[value] + ')';
          break;
        case 'a.':
          s = letters[value] + '.';
          break;
        case '(a)':
          s = '(' + letters[value] + ')';
          break;
        case 'A':
        case 'A)':
          s = bletters[value] + ')';
          break;
        case 'A.':
          s = bletters[value] + '.';
          break;
        case '(A)':
          s = '(' + bletters[value] + ')';
          break;

        case 'i':
        case 'i.':
          s = rletters[value] + '.';
          break;
        case 'i)':
          s = rletters[value] + '.';
          break;
        case '(i)':
          s = '(' + rletters[value] + '.';
          break;
        case 'I':
        case 'I)':
          s = rbletters[value] + ')';
          break;
        case 'I.':
          s = rbletters[value] + '.';
          break;
        case '(I)':
          s = rbletters[value] + '.';
          break;

        case 'abc':
        case 'abc)':
          s = slownie(value) + ')';
          break;
        case 'abc.':
          s = slownie(value) + '.';
          break;

        case '1.1.':
        case '1.1.1.':
          s = value + '.';
          for (var j = level - 1; j >= 0; j--) {
            s = levels[j] + '.' + s;
          }
      }

      // let s = value + '. ';
      if (dataset.prevvalue != s) {
        elem.innerText = s;
        dataset.prevvalue = s;
      }
      // elem.innerHTML = value + '. ';
      levels[level] = value;
      levels.length = level + 1;
    }
  }
  // console.timeEnd('renumber');
}

export default {
  name: 'w-section',
  props: {
    section: Object,
    currentSection: Object,
    sectionClass: {
      type: String,
      default: 'smart-form well'
    },
    dynamicNumbers: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.dynamicNumbers) {
      let vm = this;
      this.$nextTick(function() {
        let el = this.$el;
        renumber(el);
      });
    }
  },

  updated() {
    if (this.dynamicNumbers) {
      let vm = this;
      this.$nextTick(function() {
        let el = this.$el;

        renumber(el);
      });
    }
  }
};
</script>

<style scoped>
.tabdisableoverlay {
  left: 0px;
  top: 0px;
  text-align: center;
  right: 0px;
  bottom: 0px;
  padding-top: 10px;
  font-weight: bold;
  position: absolute;
  z-index: 1000;
  opacity: 0.7;
  background-color: white;
}
</style>
